"use strict";
var hlp = require('common/helpers');
var Menu = require('../helpers/menu');
var MENUENTRIES = require('../helpers/menuentries');
var REGEX_QUELLEN = "^([\u0030-\u0039\u0041-\u007F\u0080-\u00FF\u0100-\u017F\u0180-\u024F; ]+)\:([0-9]+)\:([0-9]+)(\-[0-9]+)?$";
var fieldEntryCtrl = function($scope, $uibModal, $sce, $http) {
  var init = function() {
    initMenu();
  };
  var initMenu = function() {
    var menu = new Menu();
    var group = null;
    if ($scope.schema.type == 'enum') {
      group = menu.createGroup();
      var $__1 = function() {
        var value = $scope.schema.values[i];
        group.addItem({
          title: value.name,
          icon: "fa-circle-o"
        }, function() {
          setEnum($scope.entry, value.value);
          menu.calcShow();
        }, function() {
          if ($scope.entry.value == value.value) {
            return false;
          }
          return true;
        });
        group.addItem({
          title: value.name,
          icon: "fa-check-circle-o"
        }, function() {
          setEnum($scope.entry, value.value);
          menu.calcShow();
        }, function() {
          if ($scope.entry.value == value.value) {
            return true;
          }
          return false;
        });
      };
      for (var i = 0; i < $scope.schema.values.length; i++) {
        $__1();
      }
    }
    group = menu.createGroup();
    if ($scope.schema.multiple) {
      group.addItem(MENUENTRIES.add, function() {
        $scope.addEntry();
      }, true);
      group.addItem(MENUENTRIES.remove, function() {
        $scope.removeEntry($scope.entry);
      }, true);
    }
    group = menu.createGroup();
    if (hlp.isSet($scope.schema.flags)) {
      group = menu.createGroup();
      if ($scope.schema.flags.remarkable) {
        group.addItem(MENUENTRIES.remarkable, function() {
          $scope.toggleFlag($scope.entry, 'remarkable');
        }, true);
      }
      if ($scope.schema.flags.unconfirmed) {
        group.addItem(MENUENTRIES.unconfirmed, function() {
          $scope.toggleFlag($scope.entry, 'unconfirmed');
        }, true);
      }
    }
    if ($scope.schema.thesaurus) {
      console.log("Added thesaurus:", $scope.schema.thesaurus);
      group.addItem(MENUENTRIES.thesaurus, $scope.showThesaurus, true);
    }
    menu.calcShow();
    $scope.menu = menu;
  };
  $scope.isValidValue = function() {
    var RE = new RegExp(REGEX_QUELLEN);
    if (!RE.test($scope.entry.value)) {
      return false;
    }
    return $scope.isValid();
  };
  var setEnum = function(entry, value) {
    entry.value = value;
  };
  init();
};
fieldEntryCtrl.$inject = ['$scope', '$uibModal', '$sce', '$http'];
module.exports = fieldEntryCtrl;
